module.exports = __webpack_public_path__ + "static/media/dharmendra.903a1c44.png";